/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import { node, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { linkBuilder } from 'services/Externals';

import featureLinkConfig from 'components/layouts/Navigation/FeatureLink/FeatureLinkConfig';

const FeatureLink = ({ className, children, path, id, view }) => {
  const { externalPath, featureEnabled, internalPath } =
    featureLinkConfig[path];

  if (featureEnabled) {
    return (
      <Link className={className} id={id} to={internalPath}>
        {children}
      </Link>
    );
  }

  return (
    <a className={className} id={id} href={linkBuilder(externalPath, view)}>
      {children}
    </a>
  );
};

FeatureLink.propTypes = {
  className: string.isRequired,
  children: node.isRequired,
  path: string.isRequired
};

FeatureLink.defaultProps = {
  className: ''
};

export default FeatureLink;
